// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common breakpoint */

/*
 ** Overal breakpoint
 **
 ** Overal breakpoint can be refered, if in case
 ** the common breakpoints doesn't suits the screen
 **
 */
`, "",{"version":3,"sources":["webpack://./src/components/library/style/breakpoint.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAQtB;;;;;;EAME","sourcesContent":["/* Common breakpoint */\n\n@value mobile: 480px;\n@value tablet: 768px;\n@value tablet-l: 768px;\n@value laptop: 1024px;\n@value desktop: 1440px;\n\n/*\n ** Overal breakpoint\n **\n ** Overal breakpoint can be refered, if in case\n ** the common breakpoints doesn't suits the screen\n **\n */\n\n@value mobile-xs: 320px;\n@value mobile-s: 360px;\n@value mobile-m: 375px;\n@value desktop-l: 1600px;\n@value desktop-xl: 1920px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile": `480px`,
	"tablet": `768px`,
	"tablet-l": `768px`,
	"laptop": `1024px`,
	"desktop": `1440px`,
	"mobile-xs": `320px`,
	"mobile-s": `360px`,
	"mobile-m": `375px`,
	"desktop-l": `1600px`,
	"desktop-xl": `1920px`
};
export default ___CSS_LOADER_EXPORT___;
